let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("iRDtW")).then(() => parcelRequire('hmJLf'));